module.exports = __webpack_public_path__ + "static/media/star.218d572c.png";